"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const InputWidget_1 = tslib_1.__importDefault(require("../widget/InputWidget"));
/**
 * @deprecated Use {@link WCAGTextField} instead.
*/
class TextBoxField extends InputWidget_1.default {
    constructor(element) {
        super(element);
    }
    parseValueFromInput(inputValue) {
        return inputValue;
    }
    setValueOnInput(value, input) {
        input.value = value;
    }
    decorateElement(element) {
        element.type = "text";
        element.classList.add("field", "textBoxField");
        element.addEventListener("focus", () => element.select());
    }
}
exports.default = TextBoxField;
//# sourceMappingURL=TextBoxField.js.map